require("./bootstrap");
import tippy from "tippy.js";

const rangeInputs = document.querySelectorAll('input[type="range"]');

function handleInputChange(input) {
    const min = input.min;
    const max = input.max;
    const val = input.value;
    input.style.backgroundSize = ((val - min) * 100) / (max - min) + "% 100%";
    if (input._tippy) {
        input._tippy.setContent(input.value + " h");
    } else {
        tippy(input, {
            offset: [0, 0],
            hideOnClick: false,
            placement: "bottom",
            content: input.value + " h",
            getReferenceClientRect: () => {
                const thumbSize = 20;
                const ratio = (input.value - min) / (max - min);
                const rect = input.getBoundingClientRect();
                return {
                    width: thumbSize,
                    height: thumbSize,
                    top: rect.top,
                    bottom: rect.bottom,
                    left: rect.left + (rect.width - thumbSize) * ratio,
                    right: rect.right + (rect.width - thumbSize) * (1 - ratio),
                };
            },
        });
    }
}

rangeInputs.forEach((input) => {
    input.addEventListener("input", (event) => handleInputChange(event.target));
    handleInputChange(input);
});
